import { useEffect, useRef } from "react";
import { useMap as useMapContextLeaflet } from "react-leaflet";
import { useParams } from "react-router-dom";
import { useIsMobile } from "@pinkyhead/dovekit"
import { decode_bbox } from "ngeohash";
import { flyOptions } from "../../../context/root/utils";
import { useRoot } from "../../../context/root";
import { useAuth } from "../../../context/auth";
import { useMap as useMapContext } from "../../../context/map";

export const MapEffect = () => {
  const map = useMapContextLeaflet();
  const { mapDispatch } = useMapContext();

  useEffect(() => {
    mapDispatch({
      type: "setMapContext",
      data: map
    })
  }, [map])

  return null;
}

export const useMap = () => {
  const { isMobile } = useIsMobile();
  const { geohash, id } = useParams();
  const { mapRefresh, rootDispatch, extraMarker } = useRoot();
  const { mapUrl } = useAuth();
  const dataLoaded = useRef<any>(null);
  const { mapContext } = useMapContext();

  
  useEffect(() => {
    if (mapContext) {
      mapContext.on("dragstart", () => {
        rootDispatch({
          type: "setShowSearchInThisArea",
          data: true
        })
      });
      mapContext.on("zoom", () => {
        rootDispatch({
          type: "setShowSearchInThisArea",
          data: true
        })
      });
      if (isMobile && extraMarker) {
        mapContext.once("click", () => {
          rootDispatch({
            type: "setExtraMarker",
            data: null,
            mapContext: mapContext
          })
        })
      }
    }
  }, [mapContext, extraMarker, isMobile])
  
  useEffect(() => {
    if (mapContext) {
      if (!dataLoaded.current && mapUrl) {
        if (geohash) {
          const [minLat, minLng, maxLat, maxLng] = decode_bbox(geohash);
          rootDispatch({
            type: "setIsMapMoving",
            data: true
          })
          mapContext.flyToBounds([
            [minLat, maxLng],
            [maxLat, maxLng],
            [maxLat, minLng],
            [minLat, minLng]
          ], flyOptions);
          mapContext.once("moveend", () => {
            fetchData({ geohash, initial: false });
          })
        }
        else {
          fetchData({ geohash: null, initial: true })
        }
    }
    }
  }, [geohash, mapUrl, mapContext, id])

  const fetchData = ({ geohash, initial }: { geohash: string | null, initial: boolean }) => {
    mapRefresh({ geohash, initial });
    dataLoaded.current = true
  }

  return {
    isMobile
  }
}
